<template lang="pug">

	section#newsApp.container.contained
		template(v-if="isFiltered")
			.filter-display
				.component.full(type="page-header")
					h1 Showing news 
						span(v-if="niceFilters.categories.length") from 
						span(v-if="niceFilters.categories.length" v-for="(category, index) in niceFilters.categories") 
							span.border-b-2 {{ category }}
							span(v-if="index < niceFilters.categories.length - 1") , 
				p.flex.justify-end.whitespace-nowrap.pl-8.cursor-pointer(@click="clearFilter()" class="hover:text-orange") Clear filters
		template(v-else)
			.component.full(type="page-header")
				h1 All News

		.news-grid-wrapper(v-if="filteredNews.length")
			.featured-item
				.news-tile.pb-8
					a.hero-image.news-tile-image(:href="filteredNews[0].url")
						img.bg-white(width="1600" height="1120" v-if="filteredNews[0].hero_image" :src="'img' + filteredNews[0].hero_image.url + '?w=1600&h=1120&fit=crop'" :alt="filteredNews[0].title")
						img(v-else :src="'img/img/no-image.png?w=1600&h=1120&fit=crop'" :alt="filteredNews[0].title")
					.news-details
						a(:href="filteredNews[0].url")
							p.text-xl.my-4 {{ filteredNews[0].title }}
						p.text-base.mb-2(v-html="formatDate(filteredNews[0].date)")
						p(v-if="filteredNews[0].excerpt" v-html="filteredNews[0].excerpt")
					
						.news-categories.mt-8
							.btn.btn-outline.mr-4.mb-4(v-for="category in filteredNews[0].news_categories" @click="toggleFilter('categories', category.slug)") {{ category.title }}
			.news-grid
				template(v-for="(article, index) in filteredNews.slice(1)")
					.news-tile.pb-8
						a(:href="article.url")
							.news-tile-image
								img.bg-white(width="800" height="560" v-if="article.hero_image" :src="'img' + article.hero_image.url + '?w=800&h=560&fit=crop'" :alt="article.title")
								img(v-else :src="'img/img/no-image.png?w=800&h=560&fit=crop'" :alt="article.title")
							.news-details
								p.text-xl.my-4 {{ article.title }}
								p.text-base.mb-2(v-html="formatDate(article.date)")
								p(v-if="article.excerpt" v-html="article.excerpt")
						.news-categories.mt-8
							.btn.btn-outline.mr-4(v-for="category in article.news_categories" @click="toggleFilter('categories', category.slug)") {{ category.title }}


		.load-more.flex.justify-center.px-4.py-12(v-if="filter.filteredResults > filteredNews.length")
			button(@click="loadMore()" ref="loadMoreBtn") Load more

		.filter-bar(
			v-if="!loading"
			:class="{ 'active' : filter.active }" 
			@click="filter.active = !filter.active"
		) Filter

		#filterModal(:class="{ 'active' : filter.active }")
			.filter-closer(@click="filter.active = !filter.active")
				include ../../../pug/partials/icon-close.pug

			.filter-container
				.filter-title.text-base.pb-2 Category
				.filter-options.mb-4
					template(v-for="(category, index) in categories")
						.filter-link(@click="toggleFilter('categories', category.slug)" :class="{ 'selected' : category.selected }") 
							span.filter-link-title {{ category.title }}
						span(v-if="index < categories.length - 1") ,&nbsp;

				.filter-title.text-base Sort
				.filter-options
					.filter-link(v-if="sort.date" class="selected") 
						span.filter-link-title Date
					.filter-link(v-else @click="sortBy('date')") 
						span.filter-link-title Date
					span , 
					.filter-link(v-if="sort.popularity" class="selected") 
						span.filter-link-title Popularity
					.filter-link(v-else @click="sortBy('popularity')") 
						span.filter-link-title Popularity

				.filter-clear(@click="clearFilter()" :class="{ 'active' : isFiltered }") Clear Filters

		.filter-overlay(:class="{' active ': filter.active }" @click="filter.active = !filter.active")
		.filter-loading(:class="{' active ': loading }")
			i.fal.fa-spinner.fa-spin.text-2xl
						
</template>

<script>
const axios = require('axios');
import NewsQuery from '../graphql/news.graphql';
import { print } from 'graphql/language/printer';
let NewsQueryString = print(NewsQuery);

export default {
	el: "news",
	name: "News",
	data() {
		return {
			loading: true,
			news: {
				all: [],
				per_page: 9,
				current_page: 1,
			},
			categories: [],
			filter: {
				active: false,
				filteredResults: 0,
				categories: []
			},
			sort: {
				date: true,
				popularity: false
			}
		}
	},
	methods: {
		getNews() {
			return axios({
				url: '/graphql',
				method: 'post',
				data: {
					query: NewsQueryString
				}
			})
		},
		toggleFilter(taxonomy, slug) {

			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});

			if (taxonomy === 'categories') {
				let category = this.categories.find(category => category.slug === slug)
				if (category.selected === true) {
					category.selected = false
					this.filter.categories = this.filter.categories.filter(category => category !== slug)
				} else {
					this.filter.categories.push(slug)
					category.selected = true
				}
			}
		},
		clearFilter() {
			this.filter.categories = []
			this.current_page = 1
			this.categories.forEach(category => {
				category.selected = false
			})
			this.sort.date = false

		},
		sortBy(choice) {
			this.sort.date = false
			this.sort.popularity = false
			switch(choice) {
				case 'date':
					this.sort.date = !this.sort.date
					break;
				case 'popularity':
					this.sort.popularity = !this.sort.popularity
					break;
			}
		},
		formatDate(date) {
			let d = new Date(date.replace(/-/g, "/"))
			let month = d.getMonth()
			let monthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(d)
			let day = d.getDate()
			let year = d.getFullYear()
			return `${monthName} ${day}, ${year}`
		},
		loadMore() {
			if ((this.news.current_page * this.news.per_page) < this.news.all.length) {
				this.news.current_page++
			}
		}
	},
	watch: {
		loading: {
			immediate: true,
			handler() {
				this.loading ? document.body.classList.add('overflow-y-hidden') : document.body.classList.remove('overflow-y-hidden')
			}
		}
	},
	computed: {
		isFiltered() {
			return this.filter.categories.length > 0
		},
		niceFilters() {
			let categories = this.categories.filter(category => category.selected === true)
			categories = categories.map(category => category.title)

			return {
				categories: categories
			}
		},
		filteredNews() {
			console.log('running filter')
			let res = []

			//- Filter
			if (this.filter.categories.length) {
				this.news.all.forEach(news => {
					let found = false
					if (this.filter.categories.length && news.news_categories !== null) {
						news.news_categories.forEach(category => {
							if (this.filter.categories.includes(category.slug)) {
								found = true
							}
						});
					}
					if (found)
						res.push(news);
				});
			}
			else {
				res = this.news.all
			}


			//- Sort

			//- Date
			if (this.sort.date) {
				console.log('Sorting by date')
				res.sort((a, b) => {
					return b.timestamp - a.timestamp
				})
			}

			if (this.sort.popularity) {
				console.log('Sorting by popularity')
				res.sort((a, b) => {
					return a.original_index - b.original_index
				})
			}

			this.filter.filteredResults = res.length

			//- Limit
			return res.slice(0, this.news.current_page * this.news.per_page)

		}
	},
	beforeMount() {
		this.getNews()
			.then((response) => {
				// console.log(response)

				let news = []
				response.data.data.news.entries.forEach((article, index) => {
					article.timestamp = Math.round(new Date(article.date.replace(/-/g, "/")).getTime()/1000);
					article.original_index = index
					news.push(article)
				})
				this.news.all = news

				let categories = []
				response.data.data.categories.terms.forEach(category => {
					category.selected = false
					categories.push(category)
				})
				this.categories = categories

				let searchParams = new URLSearchParams(document.location.search)
				let urlCategoryFilter = searchParams.get('category')
				if (urlCategoryFilter) {
					urlCategoryFilter.split(',').forEach(category => {
						this.categories.forEach(cat => {
							if (cat.slug === category) {
								this.toggleFilter('categories', category)
							}
						})
					})
				}

				this.loading = false
			})
			.catch(function (error) {
				console.log(error);
			})
			.then(function () {
				console.log('News loaded');
			});
	}
}
</script>
